<template>
  <el-dialog :title="$t('editHousekeepingType.edit')" :visible.sync="dialogVisible" width="70%" @close="closeDialog">
    <el-form :model="editHousekeepingTypeInfo" label-width="120px">
      <el-form-item :label="$t('editHousekeepingType.menuName')" required>
        <el-input v-model="editHousekeepingTypeInfo.hktName"
          :placeholder="$t('editHousekeepingType.inputMenuName')"></el-input>
      </el-form-item>

      <el-form-item :label="$t('editHousekeepingType.smallIcon')" required>
        <upload-image ref="uploadImage" :image-count="1" :initial-images="[editHousekeepingTypeInfo.hktIcon]"
          @notifyUploadCoverImage="handleImageChange"></upload-image>
      </el-form-item>

      <el-form-item :label="$t('editHousekeepingType.menuDesc')">
        <el-input v-model="editHousekeepingTypeInfo.hktDesc"
          :placeholder="$t('editHousekeepingType.inputMenuDesc')"></el-input>
      </el-form-item>

      <el-form-item :label="$t('editHousekeepingType.label')">
        <el-input v-model="editHousekeepingTypeInfo.label"
          :placeholder="$t('editHousekeepingType.inputLabel')"></el-input>
      </el-form-item>

      <el-form-item v-if="editHousekeepingTypeInfo.typeCd === '2002'" :label="$t('editHousekeepingType.skipType')"
        required>
        <el-select v-model="editHousekeepingTypeInfo.skipType" style="width:100%"
          :placeholder="$t('editHousekeepingType.selectSkipType')">
          <el-option :label="$t('editHousekeepingType.normalProduct')" value="3"></el-option>
          <el-option :label="$t('editHousekeepingType.internal')" value="1"></el-option>
          <el-option :label="$t('editHousekeepingType.external')" value="2"></el-option>
          <el-option :label="$t('editHousekeepingType.shop')" value="S"></el-option>
          <el-option :label="$t('editHousekeepingType.singleProduct')" value="P"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item
        v-if="editHousekeepingTypeInfo.typeCd === '2002' && ['1', '2'].includes(editHousekeepingTypeInfo.skipType)"
        label="URL">
        <el-input v-model="editHousekeepingTypeInfo.url" :placeholder="$t('editHousekeepingType.inputUrl')"></el-input>
        <div v-if="editHousekeepingTypeInfo.skipType === '1'" class="el-form-item__tip">
          {{ $t('editHousekeepingType.internalUrlTip') }}
        </div>
        <div v-else class="el-form-item__tip">
          {{ $t('editHousekeepingType.externalUrlTip') }}
        </div>
      </el-form-item>

      <el-form-item v-if="['S', 'P'].includes(editHousekeepingTypeInfo.skipType)"
        :label="$t('editHousekeepingType.selectShop')">
        <el-select v-model="editHousekeepingTypeInfo.shopId" style="width:100%"
          :placeholder="$t('editHousekeepingType.selectShop')" @change="selEditProducts">
          <el-option :label="$t('editHousekeepingType.selectShop')" value=""></el-option>
          <el-option v-for="item in shops" :key="item.shopId" :label="item.shopName" :value="item.shopId"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item v-if="editHousekeepingTypeInfo.skipType === 'P'" :label="$t('editHousekeepingType.selectProduct')">
        <el-select v-model="editHousekeepingTypeInfo.productId" style="width:100%"
          :placeholder="$t('editHousekeepingType.selectProduct')">
          <el-option :label="$t('editHousekeepingType.selectProduct')" value=""></el-option>
          <el-option v-for="item in products" :key="item.productId" :label="item.prodName"
            :value="item.productId"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item :label="$t('common.sort')" required>
        <el-input v-model="editHousekeepingTypeInfo.seq" :placeholder="$t('editHousekeepingType.inputSort')"></el-input>
      </el-form-item>

      <el-form-item :label="$t('editHousekeepingType.isShow')" required>
        <el-select v-model="editHousekeepingTypeInfo.isShow" style="width:100%"
          :placeholder="$t('editHousekeepingType.selectShowStatus')">
          <el-option :label="$t('common.yes')" value="Y"></el-option>
          <el-option :label="$t('common.no')" value="N"></el-option>
        </el-select>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">
        {{ $t('common.cancel') }}
      </el-button>
      <el-button type="primary" @click="saveEditHousekeepingType">
        {{ $t('common.save') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { updateHousekeepingType, queryShopsByAdmin, queryProduct } from '@/api/admin/housekeepingTypeApi'
import UploadImage from '@/components/system/UploadImage'

export default {
  name: 'EditHousekeepingType',
  components: {
    UploadImage
  },
  data() {
    return {
      dialogVisible: false,
      editHousekeepingTypeInfo: {
        hktId: '',
        hktName: '',
        hktIcon: '',
        hktDesc: '',
        label: '',
        seq: '',
        url: '',
        skipType: '',
        isShow: '',
        typeCd: '',
        shopId: '',
        storeId: '',
        productId: ''
      },
      shops: [],
      products: []
    }
  },
  methods: {
    open(params) {
      this.resetForm()
      Object.assign(this.editHousekeepingTypeInfo, params)
      this.dialogVisible = true
      this.$nextTick(() => {
        this._listEditShops()
        if (this.editHousekeepingTypeInfo.skipType === 'P' || this.editHousekeepingTypeInfo.skipType === 'S') {
          this.parseUrlInfo()
        }
        if (this.editHousekeepingTypeInfo.skipType === 'P') {
          this._listEditProducts()
        }
      })
      setTimeout(() => {
        this.$refs.uploadImage.setImages([this.editHousekeepingTypeInfo.hktIcon])
      }, 100)
    },
    closeDialog() {
      this.resetForm()
    },
    resetForm() {
      this.editHousekeepingTypeInfo = {
        hktId: '',
        hktName: '',
        hktIcon: '',
        hktDesc: '',
        label: '',
        seq: '',
        url: '',
        skipType: '',
        isShow: '',
        typeCd: '',
        shopId: '',
        storeId: '',
        productId: ''
      }
      this.shops = []
      this.products = []
    },
    parseUrlInfo() {
      if (this.editHousekeepingTypeInfo.skipType === 'S') {
        const shopIdMatch = this.editHousekeepingTypeInfo.url.match(/shopId=([^&]*)/)
        if (shopIdMatch && shopIdMatch[1]) {
          this.editHousekeepingTypeInfo.shopId = shopIdMatch[1]
        }
      } else if (this.editHousekeepingTypeInfo.skipType === 'P') {
        const shopIdMatch = this.editHousekeepingTypeInfo.url.match(/shopId=([^&]*)/)
        const productIdMatch = this.editHousekeepingTypeInfo.url.match(/productId=([^&]*)/)
        if (shopIdMatch && shopIdMatch[1]) {
          this.editHousekeepingTypeInfo.shopId = shopIdMatch[1]
        }
        if (productIdMatch && productIdMatch[1]) {
          this.editHousekeepingTypeInfo.productId = productIdMatch[1]
        }
      }
    },
    handleImageChange(images) {
      this.editHousekeepingTypeInfo.hktIcon = images.length > 0 ? images[0] : ''
    },
    async _listEditShops() {
      try {
        const res = await queryShopsByAdmin({ page: 1, row: 100 })
        this.shops = res.data
      } catch (error) {
        console.error('获取店铺列表失败:', error)
      }
    },
    async _listEditProducts() {
      try {
        const params = {
          page: 1,
          row: 100,
          shopId: this.editHousekeepingTypeInfo.shopId,
          storeId: this.editHousekeepingTypeInfo.storeId
        }
        const res = await queryProduct(params)
        this.products = res.data
      } catch (error) {
        console.error('获取商品列表失败:', error)
      }
    },
    selEditProducts() {
      if (!this.editHousekeepingTypeInfo.shopId) {
        this.products = []
        return
      }

      if (this.editHousekeepingTypeInfo.skipType === 'P') {
        const shop = this.shops.find(item => item.shopId === this.editHousekeepingTypeInfo.shopId)
        if (shop) {
          this.editHousekeepingTypeInfo.storeId = shop.storeId
          this._listEditProducts()
        }
      }
    },
    validateForm() {
      if (!this.editHousekeepingTypeInfo.hktName) {
        this.$message.error(this.$t('editHousekeepingType.validate.menuNameRequired'))
        return false
      }
      if (!this.editHousekeepingTypeInfo.hktIcon) {
        this.$message.error(this.$t('editHousekeepingType.validate.iconRequired'))
        return false
      }
      if (!this.editHousekeepingTypeInfo.seq) {
        this.$message.error(this.$t('editHousekeepingType.validate.sortRequired'))
        return false
      }
      if (!this.editHousekeepingTypeInfo.isShow) {
        this.$message.error(this.$t('editHousekeepingType.validate.showStatusRequired'))
        return false
      }
      if (!this.editHousekeepingTypeInfo.hktId) {
        this.$message.error(this.$t('editHousekeepingType.validate.idRequired'))
        return false
      }
      if (this.editHousekeepingTypeInfo.typeCd === '2002' && !this.editHousekeepingTypeInfo.skipType) {
        this.$message.error(this.$t('editHousekeepingType.validate.skipTypeRequired'))
        return false
      }
      if (this.editHousekeepingTypeInfo.skipType === 'S' && !this.editHousekeepingTypeInfo.shopId) {
        this.$message.error(this.$t('editHousekeepingType.validate.shopRequired'))
        return false
      }
      if (this.editHousekeepingTypeInfo.skipType === 'P') {
        if (!this.editHousekeepingTypeInfo.shopId) {
          this.$message.error(this.$t('editHousekeepingType.validate.shopRequired'))
          return false
        }
        if (!this.editHousekeepingTypeInfo.productId) {
          this.$message.error(this.$t('editHousekeepingType.validate.productRequired'))
          return false
        }
      }
      return true
    },
    async saveEditHousekeepingType() {
      if (!this.validateForm()) return

      try {
        const params = { ...this.editHousekeepingTypeInfo }
        params.shopId = '9999' // 固定值

        if (params.skipType === 'S') {
          if (!params.shopId) {
            this.$message.error(this.$t('editHousekeepingType.validate.shopRequired'))
            return
          }
          params.url = `/pages/cate/cate?shopId=${params.shopId}`
        }

        if (params.skipType === 'P') {
          if (!params.shopId || !params.productId) {
            this.$message.error(this.$t('editHousekeepingType.validate.productRequired'))
            return
          }
          params.url = `/pages/goods/goods?productId=${params.productId}&shopId=${params.shopId}`
        }

        await updateHousekeepingType(params)
        this.$message.success(this.$t('editHousekeepingType.updateSuccess'))
        this.dialogVisible = false
        this.$emit('success')
      } catch (error) {
        console.error('更新家政类型失败:', error)
        this.$message.error(error.message || this.$t('editHousekeepingType.updateFailed'))
      }
    }
  }
}
</script>

<style scoped>
.el-form-item__tip {
  font-size: 12px;
  color: #909399;
  margin-top: 4px;
}
</style>